(function ($) {
  Drupal.behaviors.productSocialV2 = {
    attached: false,
    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      $('.touchevents .js-share-container__share-button', context)
        .once()
        .on('click', function () {
          $('.js-share-container__social-dropdown').addClass('active');
          $('.js-share-container-overlay').addClass('active');
          $('body').addClass('no-scroll');
        });
      $('.js-share-container__social-dropdown button', context)
        .once()
        .on('click', function () {
          $('.js-share-container__social-dropdown.active').removeClass('active');
          $('.js-share-container-overlay.active').removeClass('active');
          $('body').removeClass('no-scroll');
        });
      $('.js-share-container-overlay', context)
        .once()
        .on('click', function () {
          $('.js-share-container__social-dropdown.active').removeClass('active');
          $(this).removeClass('active');
          $('body').removeClass('no-scroll');
        });
      $('.js-copy-page-link', context)
        .once()
        .on('click', function (e) {
          var $message = $('.js-copy-page-link__message', context);
          var $success = $('.js-copy-page-link__success', context).text();
          e.preventDefault();
          navigator.clipboard.writeText(window.location.href);
          $message.text($success);
          $(this).attr('aria-label', $success);
        });
    }
  };
})(jQuery);
